import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import LeadSlice from "../reduxSlice/LeadSlice";
import clientSlice from "../reduxSlice/ClientSlice";
import companySlice from "../reduxSlice/CompanySlice";
import dealSlice from "../reduxSlice/DealSlice.js";
import UtilsSlice from "../utilsSlice/UtilsSlice.js";
import NotesSlice from "../reduxSlice/NotesSlice.js";
import walkSlice from "../reduxSlice/WalkthroughSlice.js";
import inspectionSlice from "../reduxSlice/InspectionSlice.js";
import locationSlice from "../reduxSlice/LocationSlice.js";
import siteSlice from "../reduxSlice/SiteSlice.js";
import areaSlice from "../reduxSlice/AreaSlice.js";
import InjurySlice from "../reduxSlice/InjurySlice.js";
import NearMissSlice from "../reduxSlice/NearMissSlice.js";
import JobsiteSlice from "../reduxSlice/JobsiteSlice.js";
import IncidentSlice from "../reduxSlice/IncidentSlice.js";
import safetyDataSlice from "../reduxSlice/SafetyDataSlice.js";
import complianceSlice from "../reduxSlice/ComplianceSlice.js";
import VendorSlice from "../reduxSlice/VendorSlice.js";
import TimeSheetSlice from "../reduxSlice/AttendanceSlice.js";
import ProposalSlice from "../reduxSlice/ProposalSlice.js";
import employeeSlice from "../reduxSlice/EmployeeSlice.js";
import quoteSlice from "../reduxSlice/quoteSlice.js";
import InvoicesSlice from "../reduxSlice/InvoicesSlice.js";
import InventorySlice from "../reduxSlice/InventorySlice.js";
import BillingSlice from "../reduxSlice/BillingSlice.js";
// import ProposalsSlice from '../reduxSlice/ProposalsSlice.js'
import SalesOrders from "../reduxSlice/SalesOrdersSlice.js";
import surveySlice from "../reduxSlice/SurveySlice.js";
import TaskSlice from "../reduxSlice/TaskSlice.js";
import roleSlice from "../reduxSlice/RoleSlice.js";
import TaskMasterSlice from "../reduxSlice/TaskMasterSlice.js";
import departmentSlice from "../reduxSlice/DepartmentSlice.js";
import DmsSlice from "../reduxSlice/DmsSlice.js";
import OtherKycSlice from "../reduxSlice/OtherKycSlice.js";
import NastionalPotelSlice from "../reduxSlice/NastionalPortelSlice.js";
import SubsidySlice from "../reduxSlice/SubsidySlice.js";
import PriceSlice from "../reduxSlice/PriceSlice.js";
import panelSlice from "../reduxSlice/PanelSlice.js";
import solarBrandSlice from "../reduxSlice/SolarBrandSlice.js";
import solarInverterSlice from "../reduxSlice/SolarInverterSlice.js";
import NonSolarItemSlice from "../reduxSlice/NonSolarItemSlice.js";
import dmsStatusSlice from "../reduxSlice/DmsStatusSlice.js";
import inventoryInvertorSlice from "../reduxSlice/InventoryInvertorSlice.js";
import inventorySolarPanelSlice from "../reduxSlice/InventorySolarPanelSlice.js";
import PaymentReceiveSlice from "../reduxSlice/PaymentReceiveSlice.js";
import dealStatusSlice from "../reduxSlice/DealStatusSlice.js"
import teleRoleSlice from "../reduxSlice/TeleRolesSlice.js"
import customerLedgerSlice from "../reduxSlice/customerLedgerSlice.js"
import otherApplicationReducer from "../reduxSlice/OtherApplicationSlice.js"
import bankLoanReducer from "../reduxSlice/BankLoanSlice.js"

export const store = configureStore({
  reducer: {
    lead: LeadSlice,
    client: clientSlice,
    company: companySlice,
    deal: dealSlice,
    utils: UtilsSlice,
    notes: NotesSlice,
    walkthrough: walkSlice,
    inspection: inspectionSlice,
    location: locationSlice,
    site: siteSlice,
    area: areaSlice,
    injury: InjurySlice,
    nearmiss: NearMissSlice,
    jobsite: JobsiteSlice,
    incident: IncidentSlice,
    safetyData: safetyDataSlice,
    compliance: complianceSlice,
    vendor: VendorSlice,
    timesheet: TimeSheetSlice,
    proposal: ProposalSlice,
    // proposal:ProposalsSlice
    employee: employeeSlice,
    quote: quoteSlice,
    invoices: InvoicesSlice,
    inventory: InventorySlice,
    billing: BillingSlice,
    salesOrders: SalesOrders,
    survey: surveySlice,
    tasks: TaskSlice,
    role: roleSlice,
    taskMaster: TaskMasterSlice,
    department: departmentSlice,
    dms: DmsSlice,
    otherKyc: OtherKycSlice,
    nastionalPortel: NastionalPotelSlice,
    subsidy: SubsidySlice,
    PriceData: PriceSlice,
    panel: panelSlice,
    solarBrand: solarBrandSlice,
    solarInverter: solarInverterSlice,
    NonSolarItem: NonSolarItemSlice,
    dmsStatus: dmsStatusSlice,
    inventoryInvertor: inventoryInvertorSlice,
    inventorySolarPanel: inventorySolarPanelSlice,
    purchaseReceive: PaymentReceiveSlice,
    dealStatus: dealStatusSlice,
    teleRole: teleRoleSlice,
    customerLedger: customerLedgerSlice,
    otherApplication: otherApplicationReducer,
    bankLoan: bankLoanReducer,
  },

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});
